export default __webpack_public_path__ + "static/media/firststepmobile.0c4a3ccd.png";